module.exports = __webpack_public_path__ + "static/media/kjb-sportwear-1600.50d279c2.jpg";